// extracted by mini-css-extract-plugin
module.exports = {"alert":"Notification_alert__K5sOd","button":"Notification_button__WNox4","icon":"Notification_icon__FNyav"};